import { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import proj4 from "proj4";
import { register } from "ol/proj/proj4";
import { get as getProjection } from "ol/proj";

export const useProjection = () => {
  const dispatch = useDispatch();
  const { projection, projectionInitialized } = useSelector(
    (state) => state.mapConfig,
  );

  useEffect(() => {
    if (!projectionInitialized) {
      proj4.defs(
        projection,
        "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs",
      );
      register(proj4);

      dispatch({ type: "mapConfig/setProjectionInitialized", payload: true });
    }
  }, [projectionInitialized, dispatch, projection]);

  const projectionObject = useMemo(() => {
    return getProjection(projection);
  }, [projection]);

  return {
    projection,
    projectionObject,
    projectionInitialized,
  };
};
